module.exports = __webpack_public_path__ + "fb-tutorial-2-en.png?852cf9286669c34ef2ffaf60f8ec4cd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-2-en.png
// module id = T1WD
// module chunks = 46